import Nav from "../Components/Nav";
import Item from "../Components/Sub-Components/Item";
import { motion } from "framer-motion";

const standardpris = "55,00 DKK";
const menu7 = "89,00 DKK";

const Nyheder = () => {
  return (
    <div>
      <Nav />
      <div className=" relative h-[100vh] gap-5 max-h-screen">
        <motion.p
          initial={{ opacity: 0, y: "-30" }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="text-white text-center text-3xl Bebas mt-[13vh] border-b"
        >
          Nyheder
        </motion.p>

        <motion.div className="mt-[2vh] mb-10 overflow-y-auto w-full flex flex-wrap justify-center items-center">
          <Item
            img="/Assets/template.png"
            new="/Assets/news.png"
            name="Kylling & soltørrede tomater"
            desc="m. Grøn pesto"
            price={standardpris}
          />
          
          
          
        </motion.div>
      </div>
    </div>
  );
};

export default Nyheder;
